<div class="card">
    <div class="card-header" (click)="collapse=!collapse">
        <span>{{title}}</span>
        <i class="fas" [ngClass]="{'fa-angle-up': collapse, 'fa-angle-down': !collapse}"></i>
    </div>
    <div class="card-body" [isAnimated]="animated" [collapse]="collapse">
        <ng-content></ng-content>
    </div>
</div>
